import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { useTicketConfig } from '../../hooks/ticket';
import { getArenaBg } from '../../utils/matches';
import { getProxyUrl } from '../../utils/image';
import { getMatchUrl } from '../../utils/routes';
import { LEAGUES } from '../../constants/leagues';
import { slugify } from '../../utils/functionalUtils';

function TopMatch({ match, align }) {
  const {
    round,
    arenaName,
    spectators,
    homeTeamName,
    visitingTeamName,
    homeTeamAbbrv,
    status,
    homeTeamScore,
    visitingTeamScore,
    matchMinuteWithStoppageTime,
    homeTeamShortName,
  } = match;
  const [ticketConfig] = useTicketConfig(homeTeamAbbrv);
  const ticketUrl = _.get(ticketConfig, 'ticketUrl', '');
  const arenabg =
    match?.configLeagueName !== LEAGUES.FUTSAL
      ? getProxyUrl(getArenaBg(homeTeamAbbrv || homeTeamShortName), 1400, 788)
      : '/wp-content/themes/sef-leagues/images/futsal-arena.png';

  const getButtonString = () => {
    if (status === 'UPCOMING') {
      return 'Inför';
    }

    if (status === 'ONGOING') {
      return 'Följ matchen';
    }

    return 'Summering';
  };

  const scoreClass = `score-result score-result--large ${
    status === 'ONGOING' ? 'score-result--pink' : ''
  }`;

  const showNavigationToMatch = ![
    'superettanQualification',
    'allsvenskanQualification',
  ].includes(match?.configLeagueName);

  return (
    <div
      className="d-none d-lg-flex flex-column align-items-center align-self-center align-items-lg-start col-lg-6"
      style={
        align === 'right'
          ? { marginLeft: -1, paddingLeft: 0 }
          : { marginRight: -1, paddingRight: 0 }
      }
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        //   xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100%"
        height="445"
        viewBox="0 0 601 438"
        fill="none"
      >
        <path
          d="M147.447 0.108154L9.03208 13.3668C4.41508 13.8091 0.890259 17.6877 0.890259 22.3258L0.890266 414.639C0.890267 419.497 4.74451 423.477 9.59922 423.635L452.164 437.955L592 425.475C596.642 425.061 600.2 421.171 600.2 416.511L600.2 24.1068C600.2 19.2546 596.354 15.2758 591.504 15.112L147.447 0.108154Z"
          fill="url(#pattern1)"
        />
        <path
          d="M147.447 0.108154L9.03208 13.3668C4.41508 13.8091 0.890259 17.6877 0.890259 22.3258L0.890266 414.639C0.890267 419.497 4.74451 423.477 9.59922 423.635L452.164 437.955L592 425.475C596.642 425.061 600.2 421.171 600.2 416.511L600.2 24.1068C600.2 19.2546 596.354 15.2758 591.504 15.112L147.447 0.108154Z"
          fill="url(#paint1_linear_236_2872)"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          d="M9.07976 13.8645L147.462 0.608962L591.487 15.6117C596.067 15.7664 599.7 19.5241 599.7 24.1068L599.7 416.511C599.7 420.912 596.34 424.586 591.956 424.977L452.149 437.454L9.61539 423.135C5.03038 422.986 1.39027 419.227 1.39027 414.639L1.39026 22.3258C1.39026 17.9453 4.71925 14.2822 9.07976 13.8645Z"
          stroke="white"
          strokeOpacity="0.15"
        />
        <defs>
          <pattern
            id="pattern1"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlinkHref={`#${slugify(arenabg)}`}
              transform="matrix(0.000927138 0 0 0.00126904 -0.148997 0)"
            />
          </pattern>
          <linearGradient
            id="paint1_linear_236_2872"
            x1="311.996"
            y1="103.93"
            x2="270.045"
            y2="408.143"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0E204D" stopOpacity="0.25" />
            <stop offset="1" stopColor="#0E204D" />
          </linearGradient>
          <image
            id={slugify(arenabg)}
            width="1400"
            height="788"
            href={arenabg}
          />
        </defs>
      </svg>
      <div
        className="flex p-4 mx-2"
        style={{ marginTop: '-180px', height: '175px', width: '100%' }}
      >
        {status === 'ONGOING' && (
          <p className="badge badge--comp-pink mb-2">
            {matchMinuteWithStoppageTime} ’
          </p>
        )}
        <div className="heading-h4 text-transform-none mb-3 d-flex">
          {homeTeamName} – {visitingTeamName}
          <div className="d-flex align-items-center gap-1 ms-4">
            {status !== 'UPCOMING' && (
              <>
                <span className={scoreClass}>{homeTeamScore}</span>
                <span className={scoreClass}>{visitingTeamScore}</span>
              </>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          {showNavigationToMatch && (
            <a
              className="button button--primary-yellow button--large"
              href={getMatchUrl(
                match.configSeasonStartYear,
                match.id,
                homeTeamName,
                visitingTeamName,
                match.leagueName
              )}
              title=""
            >
              {getButtonString()}
            </a>
          )}
          {status === 'UPCOMING' && ticketUrl && (
            <a
              className="button button--primary-blue button--large"
              href={ticketUrl}
              title=""
            >
              Köp biljett
            </a>
          )}
          <div className="d-flex align-items-start gap-2 ms-3 col">
            <div
              style={{ width: '100px' }}
              className="d-flex flex-column justify-content-center align-items-center gap-2 col"
            >
              <img
                width="20"
                src="/wp-content/themes/sef-leagues/images/arena-logo.png"
                alt="Arena"
              />
              <p className="text-tiny-extra text-uppercase text-center">
                {arenaName}
              </p>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center gap-2 col">
              <img
                width="20"
                src={`/wp-content/themes/sef-leagues/images/${match?.configLeagueName?.replace(
                  'Qualification',
                  ''
                )}-icon.png`}
                alt="League"
              />
              <p className="text-tiny-extra text-uppercase">OMGÅNG {round}</p>
            </div>
            {spectators && (
              <div className="d-flex flex-column justify-content-center align-items-center gap-2 col">
                <img
                  width="23"
                  src="/wp-content/themes/sef-leagues/images/arena-capacity.png"
                  alt="Attendance"
                />
                <p className="text-tiny-extra text-uppercase">{spectators}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

TopMatch.propTypes = {
  match: PropTypes.shape({
    homeTeamEverySportId: PropTypes.number.isRequired,
    homeTeamAbbrv: PropTypes.string.isRequired,
    homeTeamName: PropTypes.string.isRequired,
    visitingTeamName: PropTypes.string.isRequired,
    round: PropTypes.number.isRequired,
    arenaName: PropTypes.string.isRequired,
    spectators: PropTypes.number,
    startDate: PropTypes.string.isRequired,
  }).isRequired,
};

export default TopMatch;
